import React, { useMemo } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Price } from '../../../../price/Price';
import { Typography } from '../../../../typography/Typography';
import { getDirectCompanyStatusText } from './constants';
import { CampaignGrid, CampaignColumn, ColumnHeader, ColumnValue, PartFlex } from './styles';
import { CampaignCardProps } from './types';
import { formatGeography } from './utils/formatGeography';

export const CampaignCard: React.FC<CampaignCardProps> = ({ campaign }) => {
    const t = useTranslation();
    const { regions, status, state, content, weeklyLimit, startDate, id, login } = campaign;

    const companyInfo = useMemo(() => {
        if (!login || !id) {
            return '';
        }

        return `В Директе на логине ${login} создана кампания «Продвижение в Ритме №${id}»`;
    }, [id, login]);

    return (
        <CampaignGrid>
            {companyInfo ? (
                <Typography variant="body2" pb={1}>
                    {companyInfo}
                </Typography>
            ) : null}
            <Flex direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 3 }} py={1.5}>
                <PartFlex>
                    <CampaignColumn>
                        <ColumnHeader>{t('Статус')}</ColumnHeader>
                        <ColumnValue>{getDirectCompanyStatusText(status, state)}</ColumnValue>
                    </CampaignColumn>

                    <CampaignColumn minWidth="70px">
                        <ColumnHeader>{t('Контент')}</ColumnHeader>
                        <ColumnValue>{content}</ColumnValue>
                    </CampaignColumn>

                    <CampaignColumn minWidth="134px">
                        <ColumnHeader>{t('Недельный бюджет')}</ColumnHeader>
                        <ColumnValue>
                            {
                                <Price
                                    priceInfo={{
                                        integerPart: weeklyLimit,
                                    }}
                                    weight="regular"
                                ></Price>
                            }
                        </ColumnValue>
                    </CampaignColumn>
                </PartFlex>
                <PartFlex>
                    <CampaignColumn minWidth="84px">
                        <ColumnHeader>{t('Дата начала')}</ColumnHeader>
                        <ColumnValue>{startDate}</ColumnValue>
                    </CampaignColumn>

                    <CampaignColumn>
                        <ColumnHeader>{t('География показа')}</ColumnHeader>
                        <ColumnValue>{formatGeography(regions)}</ColumnValue>
                    </CampaignColumn>
                </PartFlex>
            </Flex>
        </CampaignGrid>
    );
};
